<template>
    <!--Sidebar with Dimmer -->
    <div
        class="inset-0 flex z-[150] md:hidden"
        :class="{fixed:isMenuOpen, 'pointer-events-none':isMenuOpen}"
    >
        <!-- Sidebar -->
        <div
            class="absolute top-0 z-[150] pointer-events-auto"
            :class="[isMenuOpen&&'h-screen']"
        >
            <div
                class="group w-full mt-4 mb-2 leading-relaxed cursor-pointer px-3"
                @click.prevent="toggle()"
            >
                <!-- burger icon -->
                <svg
                    v-if="!isMenuOpen"
                    class="cursor-pointer w-8 h-8"
                    viewBox="0 0 24 24"
                >
                    <path
                        fill="currentColor"
                        d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z"
                    />
                </svg>
                <!-- XX icon -->
                <svg
                    v-else
                    class="cursor-pointer w-8 h-8"
                    viewBox="0 0 24 24"
                >
                    <path
                        fill="currentColor"
                        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                    />
                </svg>
            </div>
            <!-- Sidebar Content -->
            <div
                ref="content"
                class="transition-all duration-500 flex-1 bg-white shadow-2 absolute bottom-0 top-14 w-72 overflow-y-auto h-[calc(100vh-56px)]"
                :class="[isMenuOpen ? 'left-0': 'left-[-20rem]']"
            >
                <ul class="w-full px-5 pb-8">
                    <li
                        class="sidebar-btn"
                        @click="showLeaveAlert(routeName.HOME)"
                    >
                        <span>回首頁</span>
                    </li>
                    <li
                        class="sidebar-btn"
                        @click="$emit('openModal')"
                    >
                        <span>申請項目說明</span>
                    </li>
                    <li
                        class="sidebar-btn"
                        @click="showLeaveAlert(routeName.RECORD)"
                    >
                        <span>申請紀錄</span>
                    </li>
                    <li
                        v-if="!isMobileLogin()"
                        class="sidebar-btn"
                        @click="showLeaveAlert(routeName.LOGOUT)"
                    >
                        <span>登出</span>
                    </li>
                </ul>
            </div>
        </div>

        <transition name="fade">
            <!-- Dimmer -->
            <div
                v-if="dimmer && isMenuOpen"
                class="flex-1 bg-black bg-opacity-50 active:outline-none z-[100] mt-[3.75rem] fixed inset-0 pointer-events-auto"
                style="backdrop-filter: blur(3px);"
                @click="toggle()"
            />
        </transition>
    </div>
</template>
<script>
import { ref } from 'vue';
import routeName from '@/router/constant.js';
import { isMobileLogin } from '@/utils/is';
import { enableScroll, disableScroll } from '@/utils/style/fixedBodyScroll';
export default {
    name: 'Sidebar',
    props: {
        isMenuOpen: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['showLeaveAlert', 'update:isMenuOpen', 'openModal'],
    setup(props, { emit }) {
        const dimmer = ref(true);
        const right = ref(false);
        const showLeaveAlert = (link) => {
            emit('showLeaveAlert', link);
        };
        const toggle = () => {
            emit('update:isMenuOpen', !props.isMenuOpen);
            !props.isMenuOpen ? disableScroll() : enableScroll();
        };
        return {
            dimmer,
            right,
            routeName,
            isMobileLogin,
            toggle,
            showLeaveAlert
        };
    },
};
</script>

<style  lang="scss" scoped>
.fixed-block {
    @apply overflow-hidden block;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease-out;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.sidebar-btn {
    @apply w-full text-gray-900 border-b border-gray-100 text-lg pt-4 pb-2 cursor-pointer leading-relaxed last:border-0;
    .sidebar-text {
        @apply ml-2;
    }
}
</style>
